import { useState, useEffect } from 'react';
import axios from 'axios';
import { DashboardLayout } from '../../components/DashboardLayout';
import { Card, CardContent } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Bell, Calendar } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const StudentNotices = () => {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNotices = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/notices`);
        setNotices(response.data);
      } catch (error) {
        console.error('Error fetching notices:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchNotices();
  }, []);

  return (
    <DashboardLayout title="Notices">
      {loading ? (
        <div className="space-y-4">
          {[1, 2, 3, 4].map((i) => (
            <Card key={i} className="animate-pulse">
              <CardContent className="h-24"></CardContent>
            </Card>
          ))}
        </div>
      ) : notices.length > 0 ? (
        <div className="space-y-4">
          {notices.map((notice) => (
            <Card key={notice.id} className="card-hover" data-testid={`notice-${notice.id}`}>
              <CardContent className="p-4">
                <div className="flex items-start gap-4">
                  <div className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ${
                    notice.is_important ? 'bg-red-100' : 'bg-primary/10'
                  }`}>
                    <Bell className={`w-5 h-5 ${notice.is_important ? 'text-red-600' : 'text-primary'}`} />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-start justify-between gap-2">
                      <h4 className="font-semibold">{notice.title}</h4>
                      {notice.is_important && <Badge variant="destructive">Important</Badge>}
                    </div>
                    <p className="text-sm text-muted-foreground mt-2">{notice.content}</p>
                    <div className="flex items-center gap-2 mt-3 text-xs text-muted-foreground">
                      <Calendar className="w-3 h-3" />
                      <span>{notice.published_at?.split('T')[0]}</span>
                      <Badge variant="outline" className="text-xs">{notice.target_audience}</Badge>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      ) : (
        <Card>
          <CardContent className="py-16 text-center">
            <Bell className="w-16 h-16 mx-auto text-muted-foreground/30 mb-4" />
            <h3 className="font-heading text-xl font-semibold mb-2">No Notices</h3>
            <p className="text-muted-foreground">There are no notices at the moment.</p>
          </CardContent>
        </Card>
      )}
    </DashboardLayout>
  );
};

export default StudentNotices;
